import React, { Fragment } from "react";
import Footer from "../Footer/Footer";
import Header from "../Navbar/Header";

const Layout = ({children}:{children:any}) => {
  return (
    <Fragment>
      <Header/>
      {children}
      <Footer/>
    </Fragment>
  );
};
export default Layout;